import { apiFetch } from "../../api/apiFetch";

export const logger = async (warehouse: string, type: string, item: string, weight: number, barcode: string, barcodeType: string, fromLocation: string, toLocation: string, status: string) => {

    const userData = window.localStorage.getItem("user")
    const userObject = userData !== null ? JSON.parse(userData) : { uid: 0, name: "", permissions: "" };

    console.log(userObject);

    const body = {
        warehouse: warehouse,
        uid: userObject.uid,
        user: userObject.name,
        type: type,
        item: item,
        weight: weight,
        barcode: barcode,
        barcodeType: barcodeType,
        fromLocation: fromLocation,
        toLocation: toLocation,
        status: status
    };

    await apiFetch(`/zonestorage/log/new`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });

    return;
}

export const conveyorLogger = async (warehouse: string, type: string, item: string, fromLocation: string, toLocation: string, status: string) => {
    const userData = window.localStorage.getItem("user")
    const userObject = userData !== null ? JSON.parse(userData) : { uid: 0, name: "", permissions: "" };

    console.log(userObject);

    const body = {
        warehouse: warehouse,
        uid: userObject.uid,
        user: userObject.name,
        type: type,
        item: item,
        fromLocation: fromLocation,
        toLocation: toLocation,
        status: status
    };

    await apiFetch(`/conveyor/logs/new`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });

    return;
};